import VueRouter from "vue-router";
import { store } from "@/store/store";
import { routes } from "./routerRoutes";

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  let authStatus = store.getters.isAuthenticated;
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!authStatus) {
      tryLogin();
      authStatus = store.getters.isAuthenticated;
      if (!authStatus) {
        next({
          path: "/login",
          query: { redirect: to.fullPath },
        });
      } else {
        store.commit("closeRightDrawer");
        next();
      }
    }
    store.commit("closeRightDrawer");
    next();
  } else {
    next();
  }
});

router.onError(error => {
  if (/ChunkLoadError:.*failed./i.test(error.message)) {
    store.dispatch("triggerRefreshFlag");
  }
  else if (/Loading.*chunk.*failed./i.test(error.message)) {
    store.dispatch("triggerRefreshFlag");
  }
});

const tryLogin = async () => {
  await store.dispatch("tryLogin");
};

export default router;

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (!store.getters.isAuthenticated) {
//       next({
//         path: "/login",
//         query: { redirect: to.fullPath },
//       });
//     } else {
//       if (to.fullPath.indexOf("dashboard") < 0) {
//         store.commit("disableRightDrawer");
//       } else {
//         store.commit("disableRightDrawer");
//       }
//       next();
//     }
//   } else {
//     next();
//   }
// });
